import React, { useState, useEffect, useRef } from 'react'
import { Line,Chart } from 'react-chartjs-2';
import './exerciseProgress.css'
import { useSelector } from "react-redux";
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Select from 'react-select';

function SetExerciseGraph({ progressData }) {
  const [displaySet, setDisplaySet] = useState(-1)
  const [dateLabels, setDateLabels] = useState([])

  const [plannedDataReps, setPlannedDataReps] = useState([])
  const [plannedDataRepsUpper, setPlannedDataRepsUpper] = useState([])
  const [actualDataReps, setActualDataReps] = useState([])

  const [plannedDataWeight, setPlannedDataWeight] = useState([])
  const [actualDataWeight, setActualDataWeight] = useState([])


  const [dataReps, setDataReps] = useState({ label: 'notLoaded' })
  const [dataWeight, setDataWeight] = useState({ label: 'notLoaded' })

  const [setButtons, setSetButtons] = useState(0)
  const [currentSet,setCurrentSet] = useState(0)

  const [selectOptions, setSelectOptions] = useState(
    [{ value: 0, label: 1, key: "not loaded" }]
  )

  useEffect(() => {
    let newDateLabels = []
    let newPlannedDataOne = []
    const newPlannedDataOneUpper = []
    let newActualDataOne = []

    let newPlannedDataTwo = []
    let newActualDataTwo = []
    let date;

    progressData.forEach( entry => {
      date = (new Date(entry.shortDate.replace(/-/g, '\/')))
      date = ((date).toString()).split(' ')
      date = [date[1], date[2], date[3]].join(' ')
      newDateLabels.push(date)
    })

    setDateLabels(newDateLabels)

    progressData.forEach( entry => {
      newPlannedDataOne
        .push(parseInt(entry.expectedRepsString))
      newActualDataOne.push(parseInt(entry.actualRepsString))
    })
    
    progressData.forEach( entry => {
      newPlannedDataOneUpper
        .push(parseInt(entry.reps_upper_limit[0]))
    })

    progressData.forEach( entry => {
      newPlannedDataTwo.push(parseInt(entry.expectedWeightString))
      newActualDataTwo.push(parseInt(entry.actualWeightString))
    })

    setPlannedDataReps(newPlannedDataOne)
    setPlannedDataRepsUpper(newPlannedDataOneUpper)
    setActualDataReps(newActualDataOne)

    setPlannedDataWeight(newPlannedDataTwo)
    setActualDataWeight(newActualDataTwo)

    let newDataOne = {
      labels: dateLabels,
      datasets: [
        {
          label: `planned reps`,
          data: plannedDataReps,
          fill: false,
          backgroundColor: ({dataset,dataIndex})=>{
            const data = progressData[dataIndex]
            if (!Boolean(data))  return 
            const setData = data.setArray[0]
            if (!Boolean(setData)) return
            
            return (
              Boolean(setData.amrap)
              ? 'rgb(0,0,0)'
              : 'rgb(54, 162, 235)'
            )
          },
          borderColor: 'rgba(54, 162, 235, 0.2)',
        }, // planned
        {
          label: `planned reps high`,
          data: newPlannedDataOneUpper,
          fill: false,
          backgroundColor:'rgb(170, 66, 245)',
          borderColor: 'rgba(170, 66, 245, 0.2)',
        }, // planned upper
        {
          label: `actual reps`,
          data: actualDataReps,
          fill: false,
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgba(255, 99, 132, 0.2)',
        }, // actual
      ],
    };
    setDataReps(newDataOne)

    let newDataTwo = {
      labels: dateLabels,
      datasets: [
        {
          label: `planned weight`,
          data: plannedDataWeight,
          fill: false,
          backgroundColor: 'rgb(54, 162, 235)',
          borderColor: 'rgba(54, 162, 235, 0.2)',
        }, // planned
        {
          label: `actual weight`,
          data: actualDataWeight,
          fill: false,
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgba(255, 99, 132, 0.2)',
        }, // actual
      ],
    };
    setDataWeight(newDataTwo)

    setDisplaySet(1)
    if (selectOptions[0].key === "not loaded") {
      let array = [...Array(setButtons)].map((x, i) => ({
        label: `${i + 1}`,
        value: `${i}`,
        key: i
      }))
      setSelectOptions(array)
    }

  }, [])

  const formatSetData = (set) => {
    let plannedDataOne = []
    const plannedDataOneUpper = []
    let actualDataOne = []

    let plannedDataTwo = []
    let actualDataTwo = []

    setDisplaySet(set + 1)

    progressData.forEach(entry => {
      plannedDataOne.push(parseInt(entry.expectedReps[set]))
      plannedDataOneUpper
        .push(parseInt(entry.reps_upper_limit[set]))
      actualDataOne.push(parseInt(entry.actualReps[set]))
    })

    progressData.forEach(entry => {
      plannedDataTwo.push(parseInt(entry.expectedWeight[set]))
      actualDataTwo.push(parseInt(entry.actualWeight[set]))
    })

    let newDataOne = {
      labels: dateLabels,
      datasets: [
        {
          label: `planned reps`,
          data: plannedDataOne,
          fill: false,
          backgroundColor: ({dataset,dataIndex})=>{
            const data = progressData[dataIndex]
            if(!Boolean(data))  return 
            const setData = data.setArray[set]
            if(!Boolean(setData)) return
            
            return (
              Boolean(setData.amrap)
              ? 'rgb(0,0,0)'
              : 'rgb(54, 162, 235)'
            )
          },
          borderColor: 'rgba(54, 162, 235, 0.2)',
        }, // planned
        {
          label: `planned reps high`,
          data: plannedDataOneUpper,
          fill: false,
          backgroundColor:'rgb(170, 66, 245)',
          borderColor: 'rgba(170, 66, 245, 0.2)',
        }, // planned upper
        {
          label: `actual reps`,
          data: actualDataOne,
          fill: false,
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgba(255, 99, 132, 0.2)',
        }, // actual
      ],
    }
    setDataReps(newDataOne)

    let newDataTwo = {
      labels: dateLabels,
      datasets: [
        {
          label: `planned weight`,
          data: plannedDataTwo,
          fill: false,
          backgroundColor: 'rgb(54, 162, 235)',
          borderColor: 'rgba(54, 162, 235, 0.2)',
        }, // planned
        {
          label: `actual weight`,
          data: actualDataTwo,
          fill: false,
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgba(255, 99, 132, 0.2)',
        }, // actual
      ],
    }
    setDataWeight(newDataTwo)

  }



  if (dataReps.label === 'notLoaded') {
    let newDateLabels = [],
      newPlannedDataOne = [],
      newActualDataOne = [],
      newPlannedDataTwo = [],
      newActualDataTwo = [],
      date;
    progressData.forEach(entry => {
      date = (new Date(entry.shortDate))
      date = ((date).toString()).split(' ')
      date = [date[1], date[2], date[3]].join(' ')
      newDateLabels.push(date)
    })

    setDateLabels(newDateLabels)

    progressData.forEach(entry => {
      newPlannedDataOne.push(parseInt(entry.expectedRepsString))
      newActualDataOne.push(parseInt(entry.actualRepsString))
    })

    progressData.forEach(entry => {
      newPlannedDataTwo.push(parseInt(entry.expectedWeightString))
      newActualDataTwo.push(parseInt(entry.actualWeightString))
    })


    setSetButtons(Math.max(...progressData.map(d=>d.expectedReps.length)))


    setPlannedDataReps(newPlannedDataOne)
    setActualDataReps(newActualDataOne)

    setPlannedDataWeight(newPlannedDataTwo)
    setActualDataWeight(newActualDataTwo)

    let newDataOne = {
      labels: dateLabels,
      datasets: [
        {
          label: `planned reps`,
          data: newPlannedDataOne,
          fill: false,
          backgroundColor: 'rgb(54, 162, 235)',
          borderColor: 'rgba(54, 162, 235, 0.2)',
          // yAxisID: 'y-axis-1',
        }, // planned
        {
          label: `actual reps`,
          data: newActualDataOne,
          fill: false,
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgba(255, 99, 132, 0.2)',
          // yAxisID: 'y-axis-2',
        }, // actual
      ],
    };
    let newDataTwo = {
      labels: dateLabels,
      datasets: [
        {
          label: `planned weight`,
          data: newPlannedDataTwo,
          fill: false,
          backgroundColor: 'rgb(54, 162, 235)',
          borderColor: 'rgba(54, 162, 235, 0.2)',
          // yAxisID: 'y-axis-1',
        }, // planned
        {
          label: `actual weight`,
          data: newActualDataTwo,
          fill: false,
          backgroundColor: 'rgb(255, 99, 132)',
          borderColor: 'rgba(255, 99, 132, 0.2)',
          // yAxisID: 'y-axis-2',
        }, // actual
      ],
    };

    setDataReps(newDataOne);
    setDataWeight(newDataTwo);
  }

  const options = {
    //disable animation
    animation: {
      duration: 0
    },
    tooltips:{
      callbacks:{
        label:({index,value,datasetIndex})=>{
          const {amrap} = progressData[index].setArray[currentSet]
          const label = (
            Boolean(amrap) && datasetIndex === 0
            ? 'AMRAP'
            : value
          )
          return label
        }
      }
    },
    plugins: {
      datalabels: {
        fontFamily: "inherit",
        fontSize: '13px'
      }
    },
    maintainAspectRatio: false,
    responsive: true,
  }

  const handleMapSetOptions = () => {
    let array = [[...Array(setButtons)].map((x, i) => ({
      label: (i + 1),
      value: i,
      key: i
    }))]

    return array
  }


  return (
    <div className="graphDiv" style={{ position: 'relative' }}>
      <div className={"d-md-flex w-100"}>
        {setButtons > 1 ?
          <Col style={{ transform: 'scale(.7)' }} >
            <div >
              <p style={{ display: 'inlineBlock', marginBottom: '5px' }}>Set:</p>
              <Select
                style={{ maxHeight: '150px' }}
                className="basic-single exerciseProgressSelect"
                classNamePrefix="select"
                defaultValue={selectOptions[0]}
                name="color"
                options={selectOptions}
                onChange={(e) => {
                  formatSetData(e.value)
                  setCurrentSet(e.value)
                }}
              />
            </div>
          </Col>
          :
          null
        }
        <div className="ExerciseChartGrid">
          <div style={{height:'350px'}}>
            {/*  weight line graph  */}
            <Line
              data={dataWeight}
              redraw
              key={displaySet}
              options={options}
            />
          </div>
          <div style={{height:'350px'}}>
            {/*  reps line graph  */}
            <Line
              data={dataReps}
              redraw
              key={displaySet}
              options={options}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SetExerciseGraph